import type { TestShackReportInspection } from "@/pages/products/test-shack/models/TestShackReport";
import { TestShackReportImageDialog as SharedImageDialog } from "@/pages/products/test-shack/shared/components/report/TestShackReportImageDialog";

interface TestShackReportImageDialogProps {
	inspection: TestShackReportInspection;
	onClose: () => void;
}

export const M1TestShackReportImageDialog = ({
	inspection,
	onClose,
}: TestShackReportImageDialogProps) => (
	<SharedImageDialog
		sectionName={inspection.SectionName}
		uploadFileId={inspection.MillDrawingUploadFileId}
		label="Mill drawing"
		onClose={onClose}
	/>
);
